import { Box, Card, CardContent, Link, Typography } from "@mui/material";

import { CUSTOMER_SUPPORT_EMAIL } from "helpers/constants";

const NeedHelp = () => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h4">Need Help?</Typography>
        <Box mt={3}>
          <Typography variant="body1" component="p">
            <Link
              href={`mailto:${CUSTOMER_SUPPORT_EMAIL}?subject=Assay Marketplace Customer Support`}
              target="_blank"
              color="secondary"
              underline="always"
            >
              Email us
            </Link>{" "}
            a question.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default NeedHelp;
